/* eslint-disable react/forbid-prop-types */
import React from "react";
import { string, node, bool, oneOf, object } from "prop-types";
import { classes } from "../utils/classes";
import pureProps, { deepMergeProps } from "../utils/pureProps";
import { utilityClassName, utilityProps, utilityPropTypes } from "../props/utility";
import { spacingClassName, spacingProps, spacingPropTypes } from "../props/spacing";

const DropdownBody = ({
	Tag = "span",
	settings,
	isOpen = false,
	utility = { ...utilityProps },
	spacing = { ...spacingProps },
	align = "left",
	className = "",
	children,
	...props
}) => {
	return (
		<Tag
			className={classes(
				"dropdown-body",
				align && `dropdown-body--align-${align}`,
				isOpen && "dropdown-body--open",
				...utilityClassName(deepMergeProps({ bgColor: "white" }, pureProps(utility))),
				...spacingClassName(spacing),
				className,
			)}
			{...props}
		>
			{children}
		</Tag>
	);
};

DropdownBody.propTypes = {
	Tag: string,
	isOpen: bool,
	isPreRender: bool,
	className: string,
	settings: object,
	align: oneOf(["left", "right"]),
	utility: utilityPropTypes,
	spacing: spacingPropTypes,
	children: node,
};

export default DropdownBody;
